// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","455":"4b6f1943","762":"34448303","857":"90971ae9"}[chunkId] + ".chunk.js";
};